import { i18n } from '@/i18n'

export default () => {
  return [
    {
      icon: 'config',
      name: i18n.t('invoices.header') + ' ',
      path: 'invoices',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'invoice/new',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ]
    }
  ]
}
